import { VariablesContext } from "src/types/messages/variables";

const variablesContext: VariablesContext = {
  type: "adhoc",
};

export const emailEditorSettings = {
  enableAutofocus: true,
  enableVariables: true,
  variablesContext,
};

export const smsEditorSettings = {
  enableVariables: true,
  enableSmsStats: true,
  variablesContext,
};
